import { area, bbox, bboxPolygon, featureCollection } from "@turf/turf";
import L from "leaflet";

const MIN_ZOOM_LEVEL = 17;

export const getMinZoomLevel = (features) => {
  const collection = featureCollection(features);
  const bounds = bbox(collection);
  const poly = bboxPolygon(bounds);

  const surface = area(poly);

  const count = features.length;

  const density = count / (surface + 1);
  const score = Math.log10(density + 1) * 1000;

  // in case have a site that has few features , we need to display the ids on the default zoom level = 17 ,
  // but if we have many features in a small area , we need to zoom in for performance and readibility issues
  let minZoom = MIN_ZOOM_LEVEL;

  if (score > 250) minZoom = 24;
  else if (score > 100) minZoom = 23;
  else if (score > 35) minZoom = 22;
  else if (score > 25) minZoom = 21;
  else if (score > 9) minZoom = 20;
  else if (score > 5) minZoom = 19;
  return minZoom;
};

const PLOT_GAP = 30;

export const flyToPlot = (map, bounds, minZoom) =>
  requestAnimationFrame(() => {
    const zoom = Math.max(Math.ceil(map.getZoom()), minZoom);
    const mapLeft = map.getContainer().getBoundingClientRect().left;
    const detailsRight = Math.max(
      0,
      ...Array.from(
        document.querySelectorAll(
          ".worldmap-hud .plot-view, .worldmap-hud .plot-card"
        ),
        (panel) => panel.getBoundingClientRect().right - mapLeft
      )
    );
    const bearing = map.getBearing() * L.DomUtil.DEG_TO_RAD;
    const cornersX = [
      bounds.getNorthWest(),
      bounds.getNorthEast(),
      bounds.getSouthEast(),
      bounds.getSouthWest(),
    ].map((corner) => map.project(corner, zoom).rotate(bearing).x);
    const plotWidth = Math.max(...cornersX) - Math.min(...cornersX);
    const targetX = detailsRight + PLOT_GAP + plotWidth / 2;
    const mapWidth = map.getSize().x;
    // The whole plot must fit, its right edge included.
    const offsetX =
      detailsRight && targetX + plotWidth / 2 < mapWidth
        ? targetX - mapWidth / 2
        : 0;
    const center = map.unproject(
      map
        .project(bounds.getCenter(), zoom)
        .subtract(L.point(offsetX, 0).rotate(-bearing)),
      zoom
    );
    map.flyTo(center, zoom, { duration: 0.5 });
  });
